"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Video = exports.StyledPlayIcon = exports.Button = exports.VideoContainer = void 0;
var prism_icons_1 = require("@octanner/prism-icons");
var material_1 = require("@mui/material");
var colors_1 = require("../ThemeProvider/colors");
exports.VideoContainer = (0, material_1.styled)('div', { name: 'VideoContainer' })({
    display: 'flex',
    borderRadius: '3px',
    position: 'relative',
    '&:img, &:video': {
        maxWidth: '100%',
    },
    justifyContent: 'center',
    alignItems: 'center',
});
exports.Button = (0, material_1.styled)('button', { name: 'Button' })({
    border: 'none',
    width: 75,
    height: 75,
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    cursor: 'pointer',
    justifyContent: 'center',
    fontSize: 30,
    borderRadius: '50%',
    backgroundColor: "".concat(colors_1.tannerBlack, "B3"),
    top: '0%',
    left: '0%',
    right: '0%',
    bottom: '5%',
    margin: 'auto',
    '&:hover': {
        backgroundColor: "".concat(colors_1.tannerBlack, "CC"), // 80% opacity
    },
    '&:active': {
        backgroundColor: "".concat(colors_1.tannerBlack, "E6"), // 90% opacity
    },
    '@media screen and (max-width: 400px)': {
        width: 60,
        height: 60,
        fontSize: 22,
        bottom: '10%',
    },
});
exports.StyledPlayIcon = (0, material_1.styled)(prism_icons_1.Play, { name: 'StyledPlayIcon' })({
    color: "".concat(colors_1.tannerWhite, "CC"), // 80% opacity
});
exports.Video = (0, material_1.styled)('video', { name: 'Video' })({
    width: 'calc(100% - 12px)',
    height: 'calc(100% - 12px)',
    margin: '8px',
    borderRadius: '3px',
    '&:focus': {
        outline: "3px solid ".concat(colors_1.tannerSemantic.info.color),
        outlineOffset: '3px',
    },
});
//# sourceMappingURL=styles.js.map